module.exports = __webpack_public_path__ + "static/media/cloudversify.bd017926.svg";